module.exports = __webpack_public_path__ + "static/media/main-logo.9c9c2051.svg";